import api from '../api/api';

let loadedSource;
let loadedImage;
async function loadCropSource(source) {
  const match =
    /^https:\/\/kr\.object\.iwinv\.kr\/postpop\/([a-zA-Z0-9_-][a-zA-Z0-9._-]{0,254})$/.exec(source);
  let localUrl;
  try {
    if (match) {
      const response = await api
        .getAuth('/admin/banners/crop-source', {
          params: { key: match[1] },
          responseType: 'blob',
          suppressGlobalError: true,
        })
        .catch(async (error) => {
          let data = error.response?.data;
          if (data instanceof Blob) {
            try {
              data = JSON.parse(await data.text());
            } catch {
              data = null;
            }
          }
          const message = data?.error?.message;
          const fallback =
            error.response?.status === 403
              ? '관리자 권한이 필요합니다.'
              : error.response?.status === 401
                ? '로그인이 만료되었습니다. 다시 로그인해주세요.'
                : error.response?.status === 404
                  ? '원본 이미지를 불러오지 못했습니다. 이미지가 삭제되었는지 확인하거나 직접 선택해주세요.'
                  : '원본 이미지를 불러오지 못했습니다. 연결을 확인한 뒤 다시 시도하거나 이미지를 직접 선택해주세요.';
          throw new Error(typeof message === 'string' && message.trim() ? message : fallback);
        });
      localUrl = URL.createObjectURL(response.data);
    }
    const image = new Image();
    image.crossOrigin = 'anonymous';
    await new Promise((resolve, reject) => {
      image.onload = resolve;
      image.onerror = () =>
        reject(
          new Error(
            '원본 이미지를 읽지 못했습니다. 앱 이미지를 직접 선택하거나 다시 시도해주세요.',
          ),
        );
      image.src = localUrl || source;
    });
    return image;
  } finally {
    if (localUrl) URL.revokeObjectURL(localUrl);
  }
}

export function bannerCropRect(width, height, x = 0.5, y = 0.5, zoom = 1) {
  const w = Math.min(width, (height * 14) / 9) / zoom;
  const h = (w * 9) / 14;
  return { x: (width - w) * x, y: (height - h) * y, width: w, height: h };
}

// Generate once on admin save, never on the app's home render path.
export async function cropBannerImage(source, x, y, zoom) {
  if (loadedSource !== source || !loadedImage) {
    loadedSource = source;
    loadedImage = loadCropSource(source).catch((error) => {
      if (loadedSource === source) loadedImage = null;
      throw error;
    });
  }
  const image = await loadedImage;
  const rect = bannerCropRect(image.naturalWidth, image.naturalHeight, x, y, zoom);
  const canvas = document.createElement('canvas');
  canvas.width = 1400;
  canvas.height = 900;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('이 브라우저에서 이미지 편집을 지원하지 않습니다.');
  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, 1400, 900);
  context.drawImage(image, rect.x, rect.y, rect.width, rect.height, 0, 0, 1400, 900);
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.88));
  if (!blob) throw new Error('배너 이미지 생성에 실패했습니다.');
  return new File([blob], 'postpop-feed-banner.jpg', { type: 'image/jpeg' });
}
